import Vue from 'vue'
import uuid from 'vue-uuid'
Vue.use(uuid)